import * as api from '../api';

export const getAllCombos = async (page, pageSize) => {
    let queryString = '';
    if (page) queryString = `?page=${page}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;

    return await api.get(`/1.0/coach/combos${queryString}`);
};

export const getTH = async () => await api.get('/v5/exerciseLibrary/all');

export const getSetExerciseTemplates = async () =>
    await api.get('/2.0/coach/workoutSetExercise/template');

export const saveSetExerciseTemplate = async (template, tags) => {
    const params = { template, tags };
    return await api.post(
        '/2.0/coach/workoutSetExercise/template/save',
        params
    );
};

export const searchComboByName = async q =>
    await api.get(`/1.0/coach/combos?q=${q}`);

export const saveAsNewCombo = async setId =>
    await api.post(`/2.0/coach/workoutSet/saveAsNewCombo/${setId}`, null);
